export default __webpack_public_path__ + "media/images/paylogos/gray/dotpay@2x-9595904aa3c0ef8399a1071c995606f1.png";